function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M460.8,409.6V102.4C460.8,44.971,370.859,0,256,0S51.2,44.971,51.2,102.4v307.2C51.2,467.029,141.141,512,256,512 S460.8,467.029,460.8,409.6z M256,17.067c101.803,0,187.733,39.083,187.733,85.333S357.803,187.733,256,187.733 S68.267,148.651,68.267,102.4S154.197,17.067,256,17.067z M68.267,143.957C99.584,180.139,170.667,204.8,256,204.8 s156.416-24.661,187.733-60.843V179.2c0,46.251-85.931,85.333-187.733,85.333S68.267,225.451,68.267,179.2V143.957z M68.267,220.757 C99.584,256.939,170.667,281.6,256,281.6s156.416-24.661,187.733-60.843V256c0,46.251-85.931,85.333-187.733,85.333 S68.267,302.251,68.267,256V220.757z M68.267,297.557C99.584,333.739,170.667,358.4,256,358.4s156.416-24.661,187.733-60.843V332.8 c0,46.251-85.931,85.333-187.733,85.333S68.267,379.051,68.267,332.8V297.557z M68.267,409.6v-35.243 C99.584,410.539,170.667,435.2,256,435.2s156.416-24.661,187.733-60.843V409.6c0,46.251-85.931,85.333-187.733,85.333 S68.267,455.851,68.267,409.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgServer = function SvgServer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M256,426.667c-108.373,0-196.267-41.984-196.267-93.867v76.8c0,51.883,87.893,93.867,196.267,93.867 s196.267-41.984,196.267-93.867v-76.8C452.267,384.683,364.373,426.667,256,426.667z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 256,
    cy: 332.8,
    rx: 196.267,
    ry: 93.867
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M408.917,391.595c-58.112,67.584-166.485,91.648-248.747,99.925 c31.292,8.107,63.505,12.126,95.829,11.947c108.373,0,196.267-41.984,196.267-93.867v-76.8 C452.267,355.072,436.053,375.467,408.917,391.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M256,349.867c-108.373,0-196.267-41.984-196.267-93.867v76.8c0,51.883,87.893,93.867,196.267,93.867 s196.267-41.984,196.267-93.867V256C452.267,307.883,364.373,349.867,256,349.867z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 256,
    cy: 256,
    rx: 196.267,
    ry: 93.867
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M408.917,314.795c-58.112,67.584-166.485,91.648-248.747,99.925 c31.292,8.107,63.505,12.126,95.829,11.947c108.373,0,196.267-41.984,196.267-93.867V256 C452.267,278.272,436.053,298.667,408.917,314.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M256,273.067c-108.373,0-196.267-41.984-196.267-93.867V256c0,51.883,87.893,93.867,196.267,93.867 S452.267,307.883,452.267,256v-76.8C452.267,231.083,364.373,273.067,256,273.067z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 256,
    cy: 179.2,
    rx: 196.267,
    ry: 93.867
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M408.917,237.995c-58.112,67.584-166.485,91.648-248.747,99.925 c31.292,8.107,63.505,12.126,95.829,11.947c108.373,0,196.267-41.984,196.267-93.867v-76.8 C452.267,201.472,436.053,221.867,408.917,237.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M256,196.267c-108.373,0-196.267-41.984-196.267-93.867v76.8c0,51.883,87.893,93.867,196.267,93.867 s196.267-41.984,196.267-93.867v-76.8C452.267,154.283,364.373,196.267,256,196.267z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 256,
    cy: 102.4,
    rx: 196.267,
    ry: 93.867
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M408.917,161.195c-58.112,67.584-166.485,91.648-248.747,99.925 c31.292,8.107,63.505,12.126,95.829,11.947c108.373,0,196.267-41.984,196.267-93.867v-76.8 C452.267,124.672,436.053,145.067,408.917,161.195z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4398D1"
    },
    d: "M256,264.533c-108.373,0-196.267-41.984-196.267-93.867v17.067 c0,51.883,87.893,93.867,196.267,93.867s196.267-41.984,196.267-93.867v-17.067C452.267,222.549,364.373,264.533,256,264.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4398D1"
    },
    d: "M256,341.333c-108.373,0-196.267-41.984-196.267-93.867v17.067 c0,51.883,87.893,93.867,196.267,93.867s196.267-41.984,196.267-93.867v-17.067C452.267,299.349,364.373,341.333,256,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4398D1"
    },
    d: "M256,418.133c-108.373,0-196.267-41.984-196.267-93.867v17.067 c0,51.883,87.893,93.867,196.267,93.867s196.267-41.984,196.267-93.867v-17.067C452.267,376.149,364.373,418.133,256,418.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E8CC7"
    },
    d: "M452.267,187.733v-17.067c0,50.432-83.285,91.648-187.733,93.867V281.6 C368.981,279.381,452.267,238.165,452.267,187.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E8CC7"
    },
    d: "M452.267,264.533v-17.067c0,50.432-83.285,91.648-187.733,93.867V358.4 C368.981,356.181,452.267,314.965,452.267,264.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E8CC7"
    },
    d: "M452.267,341.333v-17.067c0,50.432-83.285,91.648-187.733,93.867V435.2 C368.981,432.981,452.267,391.765,452.267,341.333z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/server.62d7c771.svg";
export { ForwardRef as ReactComponent };